import { Component, Inject, OnInit } from '@angular/core';
import { AutoUnsubscriber, AutoUnsubscribables } from 'src/cad/shared/mixins/auto-unsubscriber.mixin';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NominationConfirmationLocationContactApi } from 'src/cad/common/services/api/nomination/confirmation/location/contact/contact';
import { ConfigService } from 'src/cad/core/services/config/config.service';
import {UserModelService} from 'cad/common/services/user/user-model-service';

@Component({
  selector: 'location-contacts-modal',
  templateUrl: './location-contacts-modal.component.html',
})
export class LocationContactsModalComponent implements OnInit {

  public noticeContactPageUrl: string;
  private locationId: string;
  public contactData: any;
  public title: string;
  private confirmationInfo: boolean;
  @AutoUnsubscriber() protected subs: AutoUnsubscribables;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public configSvc: ConfigService,
    private nominationConfirmationLocationContactApi: NominationConfirmationLocationContactApi,
    public dialogRef: MatDialogRef<LocationContactsModalComponent>,
    public userModelService: UserModelService
  ) {
    this.locationId = this.data.locationId;
    this.title = this.data.title;
    this.confirmationInfo = this.data.confirmationInfo;
    this.subs.newSub  = this.nominationConfirmationLocationContactApi.getById(this.locationId,this.data.assetNbr).subscribe((result: any) => {
      this.contactData = result;
    });
  }

  public ngOnInit(): void {
    if (this.configSvc) {
      let assetAbbr: string = this.userModelService.getCurrentContext().assetAbbr;

      this.noticeContactPageUrl = this.configSvc.getInfoPostBaseUrl() + '/notice/notice-contact-page/index?asset='+assetAbbr;
    }
  }

  public cancel = (): void => {
    this.dialogRef.close();
  }
}
